import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class UserSelectionsService {
  public readonly keyReviewsStartDateSelection: string = 'Project.Reviews.StartDate.Selection';
  public readonly keyReviewsEndDateSelection: string = 'Project.Reviews.EndDate.Selection';
  public readonly keyReviewsStatusSelection: string = 'Project.Reviews.Status.Selection';
  public readonly keyReviewsProjectNameSelection: string = 'Project.Reviews.ProjectName.Selection';
  public readonly keyReviewsProjectIdSelection: string = 'Project.Reviews.ProjectId.Selection';
  public readonly keyReviewsCompanyNumberSelection: string = 'Project.Reviews.CompanyNumber.Selection';
  public readonly keyReviewsPageSelection: string = 'Project.Reviews.Page.Selection';
  public readonly keyReviewsPageSizeSelection: string = 'Project.Reviews.PageSize.Selection';

  public get = (key: string) => `${localStorage.getItem(key) ?? ''}`;

  public set = (key: string, value: string | number | boolean) => localStorage.setItem(key, `${value ?? ''}`);
}
